<div class="tabview-custom">
  <p class="space-x-2 border-b border-gray-200 pb-2 mb-2 font-medium text-gray-800">
    <i class="pi pi-user-plus"></i> <span>Pedidos de Contacto</span>
  </p>

  @if (contactRequests.length == 0) {
    <p>Neste momento não foram encontrados pedidos
    para visualização de contacto.</p>
  } @else {
    <section class="container mx-auto bg-gray-100 p-2 space-y-2">
      @for (contactR of contactRequests ; track contactR.id; let index = $index) {
        <div class="shadow sm:overflow-hidden rounded bg-white p-6">
          <div class="flex">
            <p-avatar icon="pi pi-user" styleClass="mr-2" shape="circle"
              [style]="{ 'background-color': '#dee9fc', color: '#1a2551' }"/>
            <div class="-mt-1">
              <p class="text-sm font-medium">{{ contactR.accountName }}</p>
              <p class="text-gray-400 text-xs">({{ contactR.creationDate | date:'dd-MM-yyyy' }})</p>
            </div>
            <div class="md:hidden space-x-4 flex grow justify-end">
              <i (click)="answerContactRequest(contactR.id,true)" [pTooltip]="'Aceitar'" tooltipPosition="top"
                [tooltipStyleClass]="'text-xs'"
                class="btn text-green-600 pi pi-thumbs-up cursor-pointer"></i>
              <i (click)="answerContactRequest(contactR.id,false)" [pTooltip]="'Rejeitar'" tooltipPosition="top"
                [tooltipStyleClass]="'text-xs'"
                class="btn text-red-600 pi pi-thumbs-down cursor-pointer"></i>
            </div>
          </div>
          <div class="flex w-full mt-2 mb-2">
            <p class="flex-1 text-sm md:w-3/4">{{ contactR.message }}</p>
            <div class="space-x-4 hidden md:block">
              <i (click)="answerContactRequest(contactR.id,true)" [pTooltip]="'Aceitar'" tooltipPosition="top"
                [tooltipStyleClass]="'text-xs'"
                class="btn text-green-600 pi pi-thumbs-up cursor-pointer"></i>
              <i (click)="answerContactRequest(contactR.id,false)" [pTooltip]="'Rejeitar'" tooltipPosition="top"
                [tooltipStyleClass]="'text-xs'"
                class="btn text-red-600 pi pi-thumbs-down cursor-pointer"></i>
            </div>
          </div>
        </div>
      }
    </section>
  }

  @if (contactRequests.length > 0) {
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="0"
      [rows]="contactRequestPageInfo.totalElements"
      [totalRecords]="contactRequestPageInfo.totalElements">
    </p-paginator>
  }
</div>
